import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={17}
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="#7D7D7D"
        d="M4.158 13.338c0 .734.6 1.334 1.333 1.334h5.334c.733 0 1.333-.6 1.333-1.334v-8h-8v8ZM5.49 6.672h5.334v6.667H5.49V6.671Zm5-3.333-.666-.667H6.49l-.666.667H3.49v1.333h9.334V3.339H10.49Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M.158.672h16v16h-16z" />
      </clipPath>
    </defs>
  </svg>
)
export default SvgComponent
